(function ($) {
    $(function () {

        //HACK: stuff like this should not ever happen... ever!
        $("#fat-footer ul li ul li a").each(function () {
            if ($(this).text() == "Customer Reviews" || $(this).text() == "Quick Look Videos" || $(this).text() == "Try TI-Nspire") {
                $(this).css("color", "#CB0C0F");
            }
        });

        //Code executed only if IE browser
        if (/MSIE (\d+\.\d+);/.test(navigator.userAgent)) {
            $('#divScienceCallout1 .etcallout-link h2').each(function () {
                $(this).addClass("ie");
                $(this).css("left", "-50px");
                $(this).css("top", "100px");
            });

            $('#divScienceCallout2 .etcallout-link h2').each(function () {
                $(this).addClass("ie");
                $(this).css("left", "-40px");
                $(this).css("top", "100px");
            });
        }
    });
} (jQuery));